angular.module('avant.scripts', []);
require('./avScriptDirective.coffee');
